import styled from "styled-components";
import { safeAreaInset } from "@lib/telegram";

export const QRBottomSheetBodyContainer = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 8px;
  padding-bottom: ${safeAreaInset().bottom || 8}px;
`;